<template>
  <v-list-item
    :dense="dense"
    :class="{ 'px-3': dense }"
    :to="to ?? undefined"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <v-list-item-avatar class="mr-2">
      <v-icon
        v-if="icon"
        :color="color"
        v-text="src"
      />
      <v-img
        v-else
        contain
        :src="src"
      />
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title
        class="text-wrap font-weight-bold text-body-2"
        v-html="title"
      />
      <v-list-item-subtitle
        v-if="subtitle"
        class="text-wrap font-weight-regular"
        v-html="subtitle"
      />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
// Libraries


// Components

export default {
  name: "AvatarListCell",
  props: {
    icon: {
      default: false,
      type: Boolean,
      required: false,
    },
    dense: {
      default: false,
      type: Boolean,
      required: false,
    },
    to: {
      default: undefined,
      type: [Object],
      required: false,
    },
    src: {
      default: "Title",
      type: String,
      required: true,
    },
    title: {
      default: "",
      type: String,
      required: true,
    },
    subtitle: {
      default: "",
      type: String,
      required: false,
    },
    color: {
      default: "secondaryIcon",
      type: String,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  data: () => ({}),
};
</script>

<style></style>
